import React, { memo } from 'react';
import {
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  LoadingButton,
  Stack,
  Typography
} from 'investira.react.components';

const AvaliacoesGestorEntregaDialog = memo(props => {
  const {
    open,
    confirmada,
    disabled,
    statusEntrega,
    erroEntrega,
    isEntregando,
    onClose,
    onChangeConfirmacao,
    onConfirm
  } = props;

  return (
    <Dialog
      open={open}
      onClose={isEntregando ? undefined : onClose}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown={isEntregando}>
      <DialogTitle>
        {statusEntrega === 'enviando' ? 'Enviando questionário...' : 'Assinatura de confirmação'}
      </DialogTitle>
      <DialogContent>
        {statusEntrega === 'enviando' ? (
          <Stack data-testid="assinatura-entrega-enviando" alignItems="center" gap={2}>
            <CircularProgress />
            <DialogContentText sx={{ textAlign: 'center' }}>
              Estamos enviando sua avaliação. Isso pode levar alguns segundos.
            </DialogContentText>
            <DialogContentText sx={{ textAlign: 'center' }}>
              Aguarde a confirmação para seguir com segurança.
            </DialogContentText>
          </Stack>
        ) : (
          <>
            <DialogContentText sx={{ mb: 1 }}>
              Ao entregar, você atesta que as respostas enviadas refletem dados verdadeiros e estão
              alinhadas com a realidade da instituição.
            </DialogContentText>
            <DialogContentText sx={{ mb: 2 }}>
              <b>
                Atenção: após entregar, não será mais possível editar o questionário. Certifique-se
                de que todas as respostas estejam corretas antes de prosseguir.
              </b>
            </DialogContentText>
            {erroEntrega ? (
              <Typography data-testid="assinatura-entrega-erro" color="error" sx={{ mb: 2 }}>
                {erroEntrega}
              </Typography>
            ) : null}
            <FormControlLabel
              control={
                <Checkbox
                  data-testid="assinatura-confirmacao-checkbox"
                  checked={confirmada}
                  disabled={disabled}
                  onChange={pEvent => onChangeConfirmacao(pEvent.target.checked)}
                />
              }
              label="Confirmo a veracidade das informações prestadas."
            />
          </>
        )}
      </DialogContent>
      <DialogActions>
        {statusEntrega === 'enviando' ? (
          <LoadingButton
            variant="contained"
            data-testid="confirmar-entrega-questionario"
            loading={isEntregando}
            disabled>
            Enviando...
          </LoadingButton>
        ) : (
          <>
            <LoadingButton variant="text" onClick={onClose} disabled={disabled}>
              Cancelar
            </LoadingButton>
            <LoadingButton
              variant="contained"
              data-testid="confirmar-entrega-questionario"
              onClick={onConfirm}
              disabled={!confirmada || disabled}>
              Entregar
            </LoadingButton>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
});

export default AvaliacoesGestorEntregaDialog;
